import { classnames } from '@src/utils/classnames';
import React, { forwardRef } from 'react';
import { Carousel as CarouselDefault } from 'react-responsive-carousel';
import { ICarouselProps } from './models';

import styles from './Carousel.module.scss';
import { CarouselArrow } from './_Arrow/CarouselArrow';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface INestedComponents {
  Arrow: typeof CarouselArrow;
}

/**
 * Компонент для отрисовки карусели слайдеров.
 *
 * Базовым является https://www.npmjs.com/package/react-responsive-carousel
 */
export const Carousel = forwardRef<CarouselDefault, ICarouselProps>(
  (
    {
      className,
      style,
      id,
      showIndicators = false,
      autoFocus = true,
      dynamicHeight = false,
      useKeyboardArrows = true,
      infiniteLoop = true,
      showArrows = true,
      carouselClasses,
      ...props
    },
    ref,
  ) => {
    const classes = classnames(className, styles.root);

    return (
      <div className={classes} data-elem={'carousel'} style={style} data-id={id}>
        <CarouselDefault
          ref={ref}
          infiniteLoop={infiniteLoop}
          showIndicators={showIndicators}
          showStatus={false}
          showThumbs={false}
          autoFocus={autoFocus}
          dynamicHeight={dynamicHeight}
          useKeyboardArrows={useKeyboardArrows}
          showArrows={showArrows}
          className={carouselClasses}
          {...props}
        />
      </div>
    );
  },
) as unknown as React.ForwardRefExoticComponent<ICarouselProps & React.RefAttributes<CarouselDefault>> &
  INestedComponents;

Carousel.Arrow = CarouselArrow;
